import { ApolloClient, InMemoryCache, HttpLink } from 'apollo-boost';
import config from '../../config';

// Inicializar caché
const cache = new InMemoryCache();

const defaultOptions = {
  watchQuery: {
    fetchPolicy: 'network-only',
    errorPolicy: 'ignore',
  },
  query: {
    fetchPolicy: 'network-only',
    errorPolicy: 'all',
  },
};

// Obtener Token
const token = localStorage.getItem('jwt');

const apolloClient = new ApolloClient({
  connectToDevTools: process.browser,
  ssrMode: !process.browser, // Disables forceFetch on the server (so queries are only run once)
  link: new HttpLink({
    uri: config.api.graphqlAuth,
    credentials: 'same-origin',
    headers: {
      Authorization: token ? `Bearer ${token}` : 'Bearer ',
    },
  }),
  cache,
  defaultOptions,
});

export default apolloClient;
